import axios from '@/repositories/client';
import default_transaction from "@/defaults/default-transaction";
import media_repository from "@/repositories/media-repository";

axios.getTransactions = (query, pagination, args) => {

  args.type = args.type || null;
  args.dropdown = args.dropdown || false;

  let options = {
    params: {
      search: query,
      type: args.type,
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/transactions`, options)
    .then(response => {
      if (!args.dropdown)
        return response.data;
      else
        return response.data.data.map(transaction => ({text: transaction.id, value: transaction.id}));
    });
};

axios.getTransaction = (transaction) => {

  if (transaction === 'create')
    return new Promise((resolve => {
      resolve(_.cloneDeep(default_transaction));
    }));

  return axios.get(`athena/v1/transactions/${transaction}`)
    .then(response => {
      return response.data.data;
    });
};

axios.saveTransaction = (transaction) => {
  const url = `athena/v1/transactions` + (transaction.id ? `/${transaction.id}` : '');
  const verb = transaction.id ? 'PUT' : 'POST';

  let data = _.cloneDeep(transaction);
  data.invoices = transaction.invoices.map(i => ({id: i.id})).filter(i => !!i.id);

  return axios.request({method: verb, url: url, data: data})
    .then(response => {
      return response.data.data;
    });
};

axios.destroyTransaction = (transaction) => {
  transaction.files.forEach(file => { media_repository.deleteMedia(transaction.id, 'transactions', file); });
  return axios.delete(`athena/v1/transactions/${transaction.id}`)
    .then(response => {
      return response.data;
    });
};

export default axios;